<div
  class="pages-header"
  style="display: block"
  [ngClass]="{ blocked: data.tier != 'pro' }"
>
  <div class="d-flex align-items-center">
    <h1 class="mobile-move-title">Dashboards</h1>
  </div>

  <div class="ch-tabs workspace-tabs templates-tabs">
    <div
      class="internal"
      routerLink="/practice/dashboards/jobs-dashboard"
      routerLinkActive="active"
    >
      <i class="tio-checkmark_square_outlined"></i>
      Jobs
    </div>
    <div
      class="internal"
      routerLink="/practice/dashboards/pinned-dashboard"
      routerLinkActive="active"
    >
      <i class="tio-pin"></i> Pinned Items
    </div>
    <div
      class="internal"
      routerLink="/practice/dashboards/client-tasks-dashboard"
      routerLinkActive="active"
    >
      <i class="tio-group_equal"></i>
      Client Tasks
    </div>
    <div
      class="internal"
      routerLink="/practice/dashboards/time-tracking-dashboard"
      routerLinkActive="active"
    >
      <i class="tio-time"></i> Time tracking
    </div>
    @if (data.access_level == 1) {
      <div
        class="internal"
        routerLink="/practice/dashboards/custom-data-dashboard"
        routerLinkActive="active"
      >
        <i class="tio-briefcase"></i> Clients
      </div>
      <div
        class="internal"
        routerLink="/practice/dashboards/users-data-dashboard"
        routerLinkActive="active"
      >
        <i class="tio-group_equal"></i> Contacts
      </div>
    }
    <div
      class="internal"
      routerLink="/practice/dashboards/invites-dashboard"
      routerLinkActive="active"
    >
      <i class="tio-group_equal"></i> Invites
    </div>
  </div>
</div>
<router-outlet></router-outlet>
